import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { clsx as cx } from "clsx";

import { MenuItem } from "../types";

import styles from "./navItem.module.scss";

type NavItemHeaderProps = {
  item: MenuItem;
};

const resolveLinkPath = (childTo: string, parentTo: string) =>
  `${parentTo}/${childTo}`;

export const NavItemHeader = (props: NavItemHeaderProps) => {
  const { item } = props;
  const { label, to: headerToPath, children, icon } = item;
  const location = useLocation();

  const [expanded, setExpand] = useState(
    location.pathname.includes(headerToPath)
  );

  const onExpandChange = (e: any) => {
    e.preventDefault();
    setExpand((expanded) => !expanded);
  };

  return (
    <>
      <button
        className={cx(styles.navItem, styles.navItemHeaderButton)}
        onClick={onExpandChange}
      >
        <span className={styles.navLabel}>
          <i className={`pi ${icon} ${styles.icon}`}></i>
          {label}
        </span>
        <i
          className={cx("pi pi-angle-down", {
            [styles.chevronExpanded]: expanded,
          })}
        ></i>
      </button>

      {expanded && (
        <div className={styles.navChildrenBlock}>
          {children?.map((item, index) => {
            const key = `${item.label}-${index}`;

            const { label, children } = item;

            if (children) {
              return (
                <div key={key}>
                  <NavItemHeader
                    item={{
                      ...item,
                      to: resolveLinkPath(item.to, props.item.to),
                    }}
                  />
                </div>
              );
            }

            return (
              <NavLink
                key={key}
                to={resolveLinkPath(item.to, props.item.to)}
                className={({ isActive }) =>
                  cx(styles.navItem, { [styles.activeNavItem]: isActive })
                }
              >
                <span className={styles.navLabel}>{label}</span>
              </NavLink>
            );
          })}
        </div>
      )}
    </>
  );
};
